export default function FooterSection() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1A3A52] text-white">
      <div className="max-w-7xl mx-auto px-8 pt-16 pb-8">
        <div className="grid lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-2">
            <div className="mb-4">
              <p className="text-xl font-bold">Dr. Dan Oliver Höftmann</p>
              <p className="text-white/60 text-sm tracking-widest uppercase">Rechtsanwalt</p>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-4 max-w-sm">
              Spezialisierte Rechtsberatung in den Bereichen Sportrecht und Medizinrecht.
              Mitglied der DAV-Arbeitsgemeinschaften für Sportrecht und Medizinrecht.
            </p>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2 text-white/70 text-sm">
                <i className="ri-map-pin-line text-amber-400" />
                <span>Kröpeliner Str. 54, 18055 Rostock</span>
              </div>
              <div className="flex items-center gap-2 text-white/70 text-sm">
                <i className="ri-phone-line text-amber-400" />
                <a href="tel:+491772506951" className="hover:text-white transition-colors">
                  +49 (177) 250 69 51
                </a>
              </div>
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-4">
              Navigation
            </p>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Über mich', id: 'ueber-mich' },
                { label: 'Rechtsgebiete', id: 'rechtsgebiete' },
                { label: 'Leistungen', id: 'leistungen' },
                { label: 'Kontakt', id: 'kontakt' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-4">
              Rechtliches
            </p>
            <ul className="flex flex-col gap-3">
              {['Impressum', 'Datenschutz', 'Disclaimer'].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    rel="nofollow"
                    className="text-white/70 hover:text-white text-sm transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <p className="text-xs font-semibold uppercase tracking-widest text-white/50 mb-3">
                Mitgliedschaften
              </p>
              <div className="flex flex-col gap-2">
                <span className="text-white/60 text-xs">DAV-AG Sportrecht</span>
                <span className="text-white/60 text-xs">DAV-AG Medizinrecht</span>
                <span className="text-white/60 text-xs">Deutscher Anwaltverein</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} Dr. Dan Oliver Höftmann – Rechtsanwalt. Alle Rechte vorbehalten.
          </p>
          <p className="text-white/40 text-xs">
            Kröpeliner Str. 54 · 18055 Rostock
          </p>
        </div>

        <div className="mt-6 pt-6 border-t border-white/10">
          <p className="text-[#2a5472] text-6xl font-black tracking-tight select-none text-center">
            HÖFTMANN
          </p>
        </div>
      </div>
    </footer>
  );
}
